export default "__VITE_ASSET__97d3ebfd__"